import { processHtmlAttributes } from "../../common/html-attributes/index.js";
static {}
$ const {
  class: inputClass,
  status = "neutral",
  ...htmlAttributes
} = input;
<span ...processHtmlAttributes(htmlAttributes) class=[inputClass, "signal", `signal--${status}`]>
  <${input.renderBody}/>
</span>